import { APIClient } from '@frontend/api-utils';

export class WorkflowJsonClient extends APIClient {
    public static readonly endpoint = '/workflow-api/json/v1';

    public static async fetchWorkflowsJson(accountId: string) {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/workflows`);
        return await this.handleBlobResponse(response);
    }

    public static async fetchSingleWorkflowJson(accountId: string, workflowId: string) {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/workflows/${workflowId}`);
        return await this.handleBlobResponse(response);
    }

    public static async postWorkflowsJson(accountId: string, file: File) {
        const formData = new FormData();
        formData.append('file', file);

        const response = await this.post(`${this.endpoint}/accounts/${accountId}/workflows`, formData);
        return await this.handleBlobResponse(response);
    }
}
